export default {
  "threadLine": "_threadLine_1mzys_9",
  "commentCard": "_commentCard_1mzys_13",
  "showElbow": "_showElbow_1mzys_32"
};import "ni:sha-256;eH7unNjbBVbGghuEGyqgUTyhdE-D_idXMqXMY1MXUvg";